// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import VueMeta from 'vue-meta'
import VueCookie from 'vue-cookie'
import router from './router'
import headerBlock from './components/include/header'
import footerBlock from './components/include/footer'
import modalsBlock from './components/include/modals'
import axios from '@/router/http'
import $ from 'jquery'

Vue.config.productionTip = false
Vue.use(VueCookie)
Vue.use(VueMeta, {refreshOnceOnNavigation: true})
Vue.component('header-block', headerBlock)
Vue.component('footer-block', footerBlock)
Vue.component('modals-block', modalsBlock)
Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his childrens
      if (!(el === event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  data () {
    return {
      user: {
        uid: null
      },
      requestModal: 0,
      outsideModal: -1,
      modalText: null
    }
  },
  created () {
    var hostname = window.location.hostname
    var hostnameforcookie
    if (hostname !== 'localhost') {
      hostname = hostname.split('.')
      if (hostname.length === 3) hostnameforcookie = hostname[1] + '.' + hostname[2]
      else hostnameforcookie = hostname[0] + '.' + hostname[1]
    } else {
      hostnameforcookie = 'localhost'
      hostname = 'localhost'
    }
    let uid = this.$cookie.get('uid')
    if (uid) this.user.uid = uid
    if (!this.user.uid) {
      axios.get('https://urist1.v-avtoservice.com/list/create-uid', {
        crossDomain: true,
        headers: {'Access-Control-Allow-Origin': '*'}
      }).then(response => {
        this.user.uid = response.data.uid
        this.$cookie.set('uid', this.user.uid, {expires: '1Y', domain: hostnameforcookie})
      })
    } else {
      axios.get('https://urist1.v-avtoservice.com/list/get-uid?uid=' + this.user.uid).then(response => {
        this.user = response.data.user
      })
    }
  },
  mounted () {
    this.testWebP(function (support) {
      if (support === true) {
        document.querySelector('body').classList.add('webp')
      } else {
        document.querySelector('body').classList.add('no-webp')
      }
    })
    $(document).on('click', '.header__burger', function (event) {
      $('.menu').toggleClass('active')
      $('.header__burger').toggleClass('active')
      $('.header__logo').toggleClass('logo')
      $('body').toggleClass('lock')
    })
    $(document).on('click', '.header-white__burger', function (event) {
        $('.header-white__menu').toggleClass('active')
        $('.header-white__burger').toggleClass('active')
        $('.header-white__logo').toggleClass('logo')
        $('body').toggleClass('lock')
    })
    this.DU()
    this.closeTabs()
  },
  methods: {
    hideModal () {
      this.outsideModal++
    },
    testWebP (callback) {
      var webP = new Image()
      webP.onload = webP.onerror = function () {
        // eslint-disable-next-line
        callback(webP.height === 2)
      }
      webP.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA'
    },
    DU () {
      let originalPositions = []
      let daElements = document.querySelectorAll('[data-da]')
      let daElementsArray = []
      let daMatchMedia = []
      // Заполняем массивы
      if (daElements.length > 0) {
        let number = 0
        for (let index = 0; index < daElements.length; index++) {
          const daElement = daElements[index]
          const daMove = daElement.getAttribute('data-da')
          if (daMove !== '') {
            const daArray = daMove.split(',')
            const daPlace = daArray[1] ? daArray[1].trim() : 'last'
            const daBreakpoint = daArray[2] ? daArray[2].trim() : '767'
            const daType = daArray[3] === 'min' ? daArray[3].trim() : 'max'
            const daDestination = document.querySelector('.' + daArray[0].trim())
            if (daArray.length > 0 && daDestination) {
              daElement.setAttribute('data-da-index', number)
              // Заполняем массив первоначальных позиций
              originalPositions[number] = {
                'parent': daElement.parentNode,
                'index': indexInParent(daElement)
              }
              // Заполняем массив элементов
              daElementsArray[number] = {
                'element': daElement,
                'destination': document.querySelector('.' + daArray[0].trim()),
                'place': daPlace,
                'breakpoint': daBreakpoint,
                'type': daType
              }
              number++
            }
          }
        }
        dynamicAdaptSort(daElementsArray)

        // Создаем события в точке брейкпоинта
        for (let index = 0; index < daElementsArray.length; index++) {
          const el = daElementsArray[index]
          const daBreakpoint = el.breakpoint
          const daType = el.type

          daMatchMedia.push(window.matchMedia('(' + daType + '-width: ' + daBreakpoint + 'px)'))
          daMatchMedia[index].addListener(dynamicAdapt)
        }
      }
      // Вызов основной функции
      dynamicAdapt()
      // Основная функция
      function dynamicAdapt (e) {
        for (let index = 0; index < daElementsArray.length; index++) {
          const el = daElementsArray[index]
          const daElement = el.element
          const daDestination = el.destination
          const daPlace = el.place
          const daBreakpoint = el.breakpoint
          const daClassname = '_dynamic_adapt_' + daBreakpoint
          if (daMatchMedia[index].matches) {
            // Перебрасываем элементы
            if (!daElement.classList.contains(daClassname)) {
              let actualIndex = indexOfElements(daDestination)[daPlace]
              if (daPlace === 'first') {
                actualIndex = indexOfElements(daDestination)[0]
              } else if (daPlace === 'last') {
                actualIndex = indexOfElements(daDestination)[indexOfElements(daDestination).length]
              }
              daDestination.insertBefore(daElement, daDestination.children[actualIndex])
              daElement.classList.add(daClassname)
            }
          } else {
            // Возвращаем на место
            if (daElement.classList.contains(daClassname)) {
              dynamicAdaptBack(daElement)
              daElement.classList.remove(daClassname)
            }
          }
        }
        customAdapt()
      }
      // Функция возврата на место
      function dynamicAdaptBack (el) {
        const daIndex = el.getAttribute('data-da-index')
        const originalPlace = originalPositions[daIndex]
        const parentPlace = originalPlace['parent']
        const indexPlace = originalPlace['index']
        const actualIndex = indexOfElements(parentPlace, true)[indexPlace]
        parentPlace.insertBefore(el, parentPlace.children[actualIndex])
      }
      // Функция получения индекса внутри родителя
      function indexInParent (el) {
        var children = Array.prototype.slice.call(el.parentNode.children)
        return children.indexOf(el)
      }
      // Функция получения массива индексов элементов внутри родителя
      function indexOfElements (parent, back) {
        const children = parent.children
        const childrenArray = []
        for (let i = 0; i < children.length; i++) {
          const childrenElement = children[i]
          if (back) {
            childrenArray.push(i)
          } else {
            // Исключая перенесенный элемент
            if (childrenElement.getAttribute('data-da') == null) {
              childrenArray.push(i)
            }
          }
        }
        return childrenArray
      }
      // Сортировка объекта
      function dynamicAdaptSort (arr) {
        arr.sort(function (a, b) {
          if (a.breakpoint > b.breakpoint) { return -1 } else { return 1 }
        })
        arr.sort(function (a, b) {
          if (a.place > b.place) { return 1 } else { return -1 }
        })
      }
      // Дополнительные сценарии адаптации
      function customAdapt () {
        // const viewport_width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      }
    },
    closeTabs () {
      let checkModal = document.getElementsByClassName('popup-send-btn-wrapper')
      $(document).mouseleave(function (e) {
        if ((e.clientY < 10000000000000) && checkModal.length === 0) {
          $('.exitblock').fadeIn('fast').trigger('click')
          $('.exitblock').is(':visible')
          $('.exitblock').remove()
        }
        return null
      })
    }
  },
  watch: {
    outsideModal (val) {
      if (val > 0) {
        this.outsideModal = -1
        this.requestModal = 0
      }
    },
    $route (to, from) {
      this.DU()
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js